import React from "react";
import { UserOutlined } from "@ant-design/icons";
import { Avatar, Popover } from "antd";
import { IUser } from "../../types/User";

type TAvatarSize = "large" | "small" | "default";

interface AvatarProps {
  photo?: string | null;
  user?: IUser | null;
  size?: TAvatarSize | number;
  icon?: React.ReactNode;
  className?: string;
}

const HrnAvatar: React.FC<AvatarProps> = ({
  photo,
  user,
  size = "small",
  icon = <UserOutlined />,
  className,
  ...avatarProps
}) => {

  const profilePic = (picUrl: string | null | undefined, picSize: TAvatarSize | number) => <>
    {picUrl ? (
      <Avatar
        size={picSize}
        src={picUrl}
        {...avatarProps}
        style={{ border: "1px solid #DBDBDB" }}
      />
    ) : (
      <Avatar size={picSize} icon={icon} {...avatarProps} />
    )}
  </>;

  const profileView = <div className="profile-hover-view flex" style={{ width: "300px", borderRadius: "15px" }}>
    <div className="pic mr-[10px]">
      {profilePic(user?.profileData?.photograph, 80)}
    </div>
    <div className="info" style={{ width: "calc(100% - 90px)" }}>
      <h4 style={{ margin: "5px 0" }}>{user?.name}</h4>
      <a href={`mailto://${user?.email}`} >{user?.email}</a> <br />
      {user?.mobileNo}
    </div>
  </div>;

  return (
    <div className="relative" style={{ cursor: "pointer" }}>
      {user ?
        <Popover content={profileView}>
          {profilePic(user?.profileData?.photograph, size)}
        </Popover> :
        <>{profilePic(photo, size)}</>
      }
    </div>
  );
};

export default HrnAvatar;
